declare function require(name: string): any;

//var jsUtilities = require('../../js/jsUtilities');

class AjaxRequest {

    private _xhr: JQueryXHR;
    constructor(xhr: JQueryXHR) {
        this._xhr = xhr;
    }

    abort() {
        this._xhr.abort();
    }
}

export = AjaxRequest;